import React, { useState } from "react";
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import { Header } from "docx";
import { Heading } from "../componenet/heading";

const mockDoctors = [
  { id: 1, name: "👨‍⚕️ Dr. Sharma (Cardiology)" },
  { id: 2, name: "👩‍⚕️ Dr. Mehta (Orthopedic)" },
];

const mockDepartments = [
  { id: 1, name: "🫀 Cardiology" },
  { id: 2, name: "🦴 Orthopedic" },
];

const mockVisitNumber = () =>
  "V-" + Math.floor(Math.random() * 10000).toString();

const steps = ["Patient Details", "Visit Details", "Vitals", "Review & Submit"];

export default function OPDVisitForm() {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({
    patientId: "",
    visitNo: mockVisitNumber(),
    doctorId: "",
    deptId: "",
    reason: "",
    bp: "",
    weight: "",
    height: "",
    temperature: "",
    pulse: "",
  });

  const [patientData, setPatientData] = useState(null);

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      console.log("Submitting form:", formData);
      alert("Visit Registered ✅");
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Mock: fetch patient info by ID
  const fetchPatient = () => {
    if (formData.patientId === "101") {
      setPatientData({
        name: "👤 Rajesh Kumar",
        gender: "Male",
        age: 45,
        lastVisit: "2025-08-20",
        Address: "Gorakhpur",
      });
    } else {
      setPatientData(null);
    }
  };

  return (
    // <Box sx={{ p: 3, bgcolor: "white", borderRadius: 2, boxShadow: 3 }}>
    <Box
      sx={{
        backgroundColor: "white",
        padding: 3,
        borderRadius: 3,
        boxShadow: 3,
        // maxWidth: 800,
        margin: "auto",
        mt: 3,
      }}
    >

      
<Heading headingtext="🏥 Register OPD Visit" / >


      <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Step 1: Patient */}
      {activeStep === 0 && (
        <Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              mb: 2,
              justifyContent: "flex-start",
            }}
          >
            <TextField
              label="🔑 Patient ID"
              name="patientId"
              value={formData.patientId}
              placeholder="Enter Patient ID (e.g., 101)"
             
              onChange={handleChange}
               sx={{ maxWidth: 400,flex: 1  }} // limit width
             
            />

            <Button variant="contained" onClick={fetchPatient}>
              🔍 Fetch Patient
            </Button>
          </Box>




          {patientData && (
            <Box
              sx={{
                p: 3,
                bgcolor: "#f0f8ff",
                borderRadius: 3,
                boxShadow: 3,
                mt: 2,
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#0d47a1" }}>
                {patientData.name} ({patientData.gender})  {patientData.Address}
              </Typography>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <Box sx={{ flex: 1, minWidth: "150px", bgcolor: "#e3f2fd", p: 1.5, borderRadius: 2 }}>
                  🎂 Age: {patientData.age} yrs
                </Box>
                <Box sx={{ flex: 1, minWidth: "150px", bgcolor: "#ffe0b2", p: 1.5, borderRadius: 2 }}>
                  📅 Last Visit: {patientData.lastVisit}
                </Box>
              </Box>

              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                <Box sx={{ flex: 1, minWidth: "150px", bgcolor: "#c8e6c9", p: 1.5, borderRadius: 2 }}>
                  💉 BP: {patientData.bp}
                </Box>
                <Box sx={{ flex: 1, minWidth: "150px", bgcolor: "#f8bbd0", p: 1.5, borderRadius: 2 }}>
                  ⚖️ Weight: {patientData.weight} kg
                </Box>
                <Box sx={{ flex: 1, minWidth: "150px", bgcolor: "#d1c4e9", p: 1.5, borderRadius: 2 }}>
                  📏 Height: {patientData.height} cm
                </Box>
              </Box>

              <Box sx={{ mt: 1 }}>
                <Typography sx={{ fontStyle: "italic", color: "#555" }}>
                  This card shows patient's last recorded vitals and visit details. 🌟
                </Typography>
              </Box>
            </Box>
          )}

        </Box>
      )}

      {/* Step 2: Visit */}
      {activeStep === 1 && (
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <TextField
            fullWidth
            label="🆔 Visit Number"
            name="visitNo"
            value={formData.visitNo}
            disabled
          />
          <TextField
            select
            fullWidth
            name="doctorId"
            label="👨‍⚕️ Doctor"
            value={formData.doctorId}
            onChange={handleChange}
          >
            {mockDoctors.map((doc) => (
              <MenuItem key={doc.id} value={doc.id}>
                {doc.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            name="deptId"
            label="🏥 Department"
            value={formData.deptId}
            onChange={handleChange}
          >
            {mockDepartments.map((dept) => (
              <MenuItem key={dept.id} value={dept.id}>
                {dept.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="📝 Reason for Visit"
            name="reason"
            value={formData.reason}
            onChange={handleChange}
          />
        </Box>
      )}

      {/* Step 3: Vitals */}
      {activeStep === 2 && (
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <TextField
            fullWidth
            label="💉 Blood Pressure (mmHg)"
            name="bp"
            value={formData.bp}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            label="⚖️ Weight (kg)"
            name="weight"
            value={formData.weight}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            label="📏 Height (cm)"
            name="height"
            value={formData.height}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            label="🌡️ Temperature (°C)"
            name="temperature"
            value={formData.temperature}
            onChange={handleChange}
          />
          <TextField
            fullWidth
            label="❤️ Pulse (bpm)"
            name="pulse"
            value={formData.pulse}
            onChange={handleChange}
          />
        </Box>
      )}

      {/* Step 4: Review */}
      {activeStep === 3 && (
        <Box>
          <Typography variant="h6">🔍 Review Details</Typography>
          <pre style={{ background: "#f4f4f4", padding: "10px" }}>
            {JSON.stringify(formData, null, 2)}
          </pre>
        </Box>
      )}

      {/* Buttons */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          variant="outlined"
        >
          ⬅️ Back
        </Button>
        <Button variant="contained" onClick={handleNext}>
          {activeStep === steps.length - 1 ? "✅ Submit" : "➡️ Next"}
        </Button>
      </Box>
    </Box>
  );
}
